import { useState } from "react";

const faqs = [
  {
    q: "本当に1〜2週間で動くものができるのですか?",
    a: "はい。AI活用開発では、人間とAIが分担して開発を進めるため、従来の3〜5倍の速度で開発が進みます。ただし、スコープを適切に絞ることが重要です。初日に要件を確定し、優先順位をつけて確実に完了させます。",
  },
  {
    q: "品質は大丈夫ですか?",
    a: "毎日のレビューで品質を担保しています。AIが生成したコードは必ず人間がレビューし、テストも実施します。また、受入基準を事前に合意することで、期待値のずれを防ぎます。",
  },
  {
    q: "セキュリティ面は問題ないですか?",
    a: "情報システム部門のご要件に応じて柔軟に対応します。環境分離(開発/本番)、データ匿名化、アクセスログ管理、NDA締結など、必要なセキュリティ対策を講じます。クラウド/閉域網の選択も可能です。",
  },
  {
    q: "途中で仕様を変更できますか?",
    a: "期間内であれば、追加費用なしで方向修正が可能です。毎日のレビューでフィードバックをいただき、翌日には反映します。大幅なスコープ変更の場合は、次期間での対応となります。",
  },
  {
    q: "契約や支払いの流れは?",
    a: "まずは無料相談(15分)で要件をヒアリングし、お見積書をお出しします。発注確定後、着手金50%をお支払いいただき、開発開始。成果物納品後に残金50%をお支払いいただきます。NDAや契約書は弊社でひな形をご用意しております。",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-white py-20">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900">よくあるご質問</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-2xl overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="text-sm font-bold text-gray-900 pr-4">{faq.q}</span>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${open === i ? "subtract" : "add"}-line text-blue-600 text-lg`}></i>
                </span>
              </button>
              {open === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
